var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "json-nested-block",
      class: {
        "json-nested-block--compact": _vm.compact,
        "json-nested-block--nested": _vm.depth > 0,
        "json-nested-block--asset-detail": _vm.isAssetDetailTable
      }
    },
    [
      _vm.tableMode
        ? [
            _vm.sectionTitle
              ? _c("div", { staticClass: "json-nested-section-title" }, [
                  _vm._v(_vm._s(_vm.sectionTitle))
                ])
              : _vm._e(),
            _c(
              "el-table",
              {
                staticClass: "json-nested-table",
                class: {
                  "json-nested-table--fit-content": _vm.isAssetDetailTable
                },
                attrs: {
                  data: _vm.pagedRows,
                  border: "",
                  stripe: "",
                  size: "mini",
                  "max-height": _vm.tableMaxHeight
                }
              },
              _vm._l(_vm.tableColumns, function(col) {
                return _c("el-table-column", {
                  key: col,
                  attrs: {
                    prop: col,
                    label: _vm.colLabel(col),
                    "min-width": _vm.columnWidth(col),
                    "show-overflow-tooltip": !_vm.isAssetDetailTable
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.isNested(scope.row[col])
                              ? _c("json-nested-block", {
                                  attrs: {
                                    value: scope.row[col],
                                    depth: _vm.depth + 1,
                                    compact: true,
                                    "field-labels": _vm.fieldLabels,
                                    "section-title": _vm.colLabel(col)
                                  }
                                })
                              : _c(
                                  "span",
                                  { staticClass: "json-nested-primitive" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatPrimitive(scope.row[col])
                                      )
                                    )
                                  ]
                                )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              }),
              1
            ),
            _vm.allRows.length > _vm.pageSize
              ? _c(
                  "div",
                  { staticClass: "json-nested-pager" },
                  [
                    _c("span", { staticClass: "json-nested-pager-total" }, [
                      _vm._v("共 " + _vm._s(_vm.allRows.length) + " 条")
                    ]),
                    _c("el-pagination", {
                      attrs: {
                        small: "",
                        layout: "prev, pager, next",
                        "current-page": _vm.currentPage,
                        "page-size": _vm.pageSize,
                        total: _vm.allRows.length
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm.objectMode
        ? [
            _vm.sectionTitle
              ? _c("div", { staticClass: "json-nested-section-title" }, [
                  _vm._v(_vm._s(_vm.sectionTitle))
                ])
              : _vm._e(),
            _c("table", { staticClass: "json-nested-kv" }, [
              _c(
                "tbody",
                _vm._l(_vm.objectEntries, function(entry) {
                  return _c("tr", { key: entry.key }, [
                    _c("th", { staticClass: "json-nested-kv-key" }, [
                      _vm._v(_vm._s(_vm.colLabel(entry.key)))
                    ]),
                    _c(
                      "td",
                      { staticClass: "json-nested-kv-val" },
                      [
                        _vm.isNested(entry.val)
                          ? _c("json-nested-block", {
                              attrs: {
                                value: entry.val,
                                depth: _vm.depth + 1,
                                compact: true,
                                "field-labels": _vm.fieldLabels
                              }
                            })
                          : _c(
                              "span",
                              { staticClass: "json-nested-primitive" },
                              [_vm._v(_vm._s(_vm.formatPrimitive(entry.val)))]
                            )
                      ],
                      1
                    )
                  ])
                }),
                0
              )
            ])
          ]
        : _vm.primitiveArrayMode
        ? [
            _vm.sectionTitle
              ? _c("div", { staticClass: "json-nested-section-title" }, [
                  _vm._v(_vm._s(_vm.sectionTitle))
                ])
              : _vm._e(),
            _c(
              "ul",
              { staticClass: "json-nested-list" },
              _vm._l(_vm.normalizedValue, function(item, idx) {
                return _c("li", { key: idx }, [
                  _vm._v(_vm._s(_vm.formatPrimitive(item)))
                ])
              }),
              0
            )
          ]
        : [
            _c("span", { staticClass: "json-nested-primitive" }, [
              _vm._v(_vm._s(_vm.formatPrimitive(_vm.normalizedValue)))
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }